import React from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import Typed from 'react-typed';
import VisibilitySensor from 'react-visibility-sensor';
import { useHistory } from "react-router";

const programmingText = `
<span style="font-family: 'IBM Plex Mono', monospace; color: white;">
<span style="color: Magenta;">import</span> <span style="color: LightSkyBlue;">OracliomStaff</span> <span style="color: Magenta;">from</span> "<span style="color: LightSkyBlue;">Oracliom</span>"; <br/><br/>
<span style="color: CornflowerBlue;">const</span> <span style="color: LightSkyBlue;">idea</span> = <span style="color: Coral;">"COVID Predictor"</span>;<br/>
<span style="color: CornflowerBlue;">const</span> <span style="color: GoldenRod;">produceSolution</span> =  (<span style="color: LightSkyBlue;">idea</span>) => {<br/>
    &nbsp;&nbsp;<span style="color: Magenta;">return</span> <span style="color: LightSkyBlue;">OracliomStaff</span>.<span style="color: GoldenRod;">generate</span>(<span style="color: LightSkyBlue;">idea</span>);<br/>
}<br/><br/>

🚀<span style="color: GoldenRod;">produceSolution</span>(<span style="color: LightSkyBlue;">idea</span>);
</span>
`
//

const About = React.forwardRef((props, ref) => {
  const history = useHistory();
  const changeVisibility = (isVisible)=>{
    if(isVisible){
      history.push('landing?section=aboutus&type=scrolled')
    }
  }
  return (
    <VisibilitySensor onChange={changeVisibility}>
    <styledComponents.AboutContainer ref={ref}>
      <Container>
        <Row>
          <Col md>
            <styledComponents.HeadTitle >ABOUT US</styledComponents.HeadTitle>
            <styledComponents.Title>
            WE ARE YOUR TECH PARTNER IN YOUR STARTUP
          </styledComponents.Title>
            <styledComponents.Description>
            We are a team of engineers, designers, and IT experts who help entrepreneurs and new ventures to build tech-based solutions.
            We have already successfully launched a few startups and we want the same for you.
            </styledComponents.Description>
            <styledComponents.ContainerTypedPhone>
              <Typed
                strings={[programmingText]}
                typeSpeed={30}
              />
            </styledComponents.ContainerTypedPhone>
          </Col>
          
            <Col md>
              <styledComponents.ContainerTypedDesktop>
                <Typed
                  strings={[programmingText]}
                  typeSpeed={30}
                />
              </styledComponents.ContainerTypedDesktop>
            </Col>
        </Row>
      </Container>
    </styledComponents.AboutContainer>
    </VisibilitySensor>
  );
});

export default About;